import { render, staticRenderFns } from "./operateList.vue?vue&type=template&id=5939ba0e&"
import script from "./operateList.vue?vue&type=script&lang=js&"
export * from "./operateList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/catalogue/operateList.vue"
export default component.exports